<template>
  <div>
    <template v-if="isHorizontal">
      <!-- <v-row justify="start">
        <v-col
          v-for="(checkboxItemConfig, index) in items"
          :key="index"
        >
          <universal-input
            v-model="collection[checkboxItemConfig.itemName]"
            class="mt-0"
            :config="getCheckBoxItemConfig(checkboxItemConfig)"
            @input="updateValue"
          />
        </v-col>
      </v-row> -->
      <vue-horizontal
        scroll
        :button="false"
        class="horizontal"
      >
        <section
          v-for="(checkboxItemConfig, index) in items"
          :key="index"
        >
          <!-- <universal-input
            v-model="collection[checkboxItemConfig.itemName]"
            class="mt-0"
            :config="getCheckBoxItemConfig(checkboxItemConfig)"
            @input="updateValue"
          /> -->
          <v-checkbox
            v-model="collection[checkboxItemConfig.propName]"
            :label="checkboxItemConfig.label"
            @input="updateValue"
          ></v-checkbox>
        </section>
      </vue-horizontal>
    </template>
    <template v-else>
      <!--
        v-model="collection[checkboxItemConfig.itemName]" -->

      <!-- <universal-input
        v-for="checkboxItemConfig in items"
        :key="checkboxItemConfig.itemName"
        v-model="collection[checkboxItemConfig.itemName]"
        :config="getCheckBoxItemConfig(checkboxItemConfig)"
        @input="updateValue"
      /> -->
      <v-checkbox
        v-model="collection[checkboxItemConfig.propName]"
        :label="checkboxItemConfig.label"
        @input="updateValue"
      ></v-checkbox>
    </template>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, watch, toRefs } from 'vue'
import VueHorizontal from 'vue-horizontal'
import { useStore } from '@/store'
import UniversalInput from './UniversalInput'

const collection = ref({})
const store = useStore()
const props = defineProps({ value: {},
  config: {
    type: Object,
    required: true,
  } })
const { config, value } = toRefs(props)
console.log('config', config)
const isHorizontal = ref(config.value.type.isHorizontal)
const items = computed(() => {
  if (config.value.type.storeName) {
    console.log('this.storeName', config.value.type.storeName)

    return store.getters[config.value.type.storeName]
  }

  return config.value.type.groupItems || []
})

const getCheckBoxItemConfig = checkboxItemConfig => {
  const itemConfig = {}
  itemConfig.propName = `${config.value.propName}_${checkboxItemConfig.itemName}`
  itemConfig.label = checkboxItemConfig.label
  itemConfig.type = { name: 'checkbox' }

  return itemConfig
}

const emit = defineEmits(['input'])

const updateValue = newValue => {
  emit('input', collection.value)
  console.log('newValue', newValue)
  console.log('collection.value', collection.value)
}

onMounted(() => {
  if (typeof config.value.defaultValue !== 'undefined') {
    console.log('radioGroup defaultValue', config.value.defaultValue)
    updateValue(config.value.defaultValue)
  }
})

</script>
